export class ArticleUsagePlausiPropertyDef {
  public static readonly APPLIED_ROTATION_ANGLE: string = 'appliedRotationAngle';
  public static readonly IS_SWITCHED: string = 'isSwitched';
  public static readonly CUSTOM_APPLIED_ROTATION_ANGLE: string = 'customAppliedRotationAngle';

  public static readonly TOTAL_LOGIC_CURRENT_CONSUMPTION: string = 'totalLogicCurrentConsumption';
  public static readonly TOTAL_SENSOR_CURRENT_CONSUMPTION: string = 'totalSensorCurrentConsumption';
  public static readonly TOTAL_ACTUATOR_CURRENT_CONSUMPTION: string = 'totalActuatorCurrentConsumption';

  public static readonly USED_LOGIC_CHANNEL_COUNT: string = 'usedLogicChannelCount';
  public static readonly USED_SENSOR_CHANNEL_COUNT: string = 'usedSensorChannelCount';
  public static readonly USED_ACTUATOR_CHANNEL_COUNT: string = 'usedActuatorChannelCount';
  public static readonly DETAILED_ENTRY_FOR_CURRENT_CONSUMPTION: string = 'isDetailedEntryForCurrentConsumption';
  public static readonly LAST_TERMINAL_IN_CIRCUIT: string = 'isLastTerminalInCircuit';
}
